/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Buttons.module.css';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
// input with number
class NumberInput extends Component {


  // must be arrow or set inside JSX:
  // onChange={e => this.onInputChange(e)}
  onInputChange = event => {
    // can't use state here since may not be updated yet
    this.props.onChange(event.target.value);
  };


  render() {
    // const value = this.obj.value;
    const obj = this.props.obj;

    return (
      <div className={styles.inputContainer}>
        <label className={styles.label} htmlFor={obj.label}>
          {obj.label}
        </label>
        <input
          id={obj.label}
          className={`${styles.input} ${styles.sized} ${styles.number}`}
          type='number'
          value={this.props.obj.value}
          min={obj.min}
          max={obj.max}
          step={obj.step}
          onChange={this.onInputChange}
          // dataToolTip={this.props.dataToolTip}
        />
      </div>
    );
  }
}

export default NumberInput;
